<template>
  <div id="return-requests">
    <div class="p-6 loading-table" v-if="loading">
      <spinner-color />
    </div>

    <div v-else>
      <div class="mb-4">
        <vs-alert :active="!!errorMsg" color="danger" icon="new_releases">
          <span>{{ errorMsg }}</span>
        </vs-alert>
      </div>

      <vs-card>
        <div class="flex flex-wrap items-center justify-between w-full">
          <div>
            <feather-icon icon="RewindIcon" svgClasses="h-4 w-4"></feather-icon>
            <h3
              class="font-bold mb-2 ml-3"
              style="display: inline-block; font-size: 1.125rem"
            >
              طلبات تحتاج متابعتك
            </h3>
          </div>

          <div class="flex items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-2 mr-2">
              <div
                style="
                  font-family: 'Cairo', sans-serif !important;
                  padding: 0.75rem !important;
                  border-radius: 0.25rem !important;
                "
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">عرض {{ perPage }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <ul style="min-width: 8rem">
                  <vs-dropdown-item @click="setPerPage(10)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop">
                      <span>10</span>
                    </li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(20)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop">
                      <span>20</span>
                    </li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(50)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop">
                      <span>50</span>
                    </li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(100)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop">
                      <span>100</span>
                    </li>
                  </vs-dropdown-item>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button
              style="font-family: 'Cairo', sans-serif !important"
              type="border"
              color="primary"
              class="mb-2"
              :disabled="refreshing"
              @click="fetchReturnRequests()"
            >
              تحديث
            </vs-button>
          </div>
        </div>

        <vs-divider class="m-0 mt-4" />

        <vs-table :data="requests" noDataText="">
          <template slot="thead">
            <vs-th>الكود</vs-th>
            <vs-th>المستلم</vs-th>
            <vs-th>هاتف</vs-th>
            <vs-th>المحافظة</vs-th>
            <vs-th>المنطقة</vs-th>
            <vs-th>نوع طلب المرتجع</vs-th>
            <vs-th>سبب المرتجع</vs-th>
            <vs-th>اسم المندوب</vs-th>
            <vs-th>رقم المندوب</vs-th>
            <vs-th>الأوامر</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :key="tr.id" v-for="tr in data">
                <vs-td>
                  <router-link :to="'/OrderDetails/' + tr.code">
                    <p class="font-medium truncate code">{{ tr.code }}</p>
                  </router-link>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.receiver || "-" }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.phone1 || "-" }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.gov_name || "-" }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.location || "-" }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ returnTypeText(tr.return_type)}}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.return_reason_text || "-" }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.captain_name || "-" }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ captainPhone(tr) }}
                  </p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <vs-button
                    style="font-family: 'Cairo', sans-serif !important"
                    size="small"
                    color="success"
                    type="filled"
                    :disabled="
                      !tr.return_request_type || actionLoadingOrderId === tr.id
                    "
                    @click.stop="openConfirm(tr, 'accept')"
                  >
                    قبول
                  </vs-button>
                  <vs-button
                    style="font-family: 'Cairo', sans-serif !important"
                    size="small"
                    color="danger"
                    type="filled"
                    class="ml-2"
                    :disabled="
                      !tr.return_request_type || actionLoadingOrderId === tr.id
                    "
                    @click.stop="openConfirm(tr, 'reject')"
                  >
                    رفض
                  </vs-button>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vs-card>

      <vs-popup
        class="holamundo"
        :title="confirmTitle"
        :active.sync="confirmActive"
        @close="resetConfirm()"
      >
        <p style="padding-bottom: 1rem">{{ confirmText }}</p>

        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          @click.stop="submitConfirm()"
          :color="confirmAction === 'accept' ? 'success' : 'danger'"
          class="mr-3"
          type="filled"
          :disabled="confirmSubmitting"
        >
          {{ confirmAction === "accept" ? "قبول" : "رفض" }}
        </vs-button>
        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          @click="confirmActive = false"
          color="primary"
          type="filled"
          :disabled="confirmSubmitting"
        >
          إلغاء
        </vs-button>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";

export default {
  components: {
    SpinnerColor,
  },
  data() {
    return {
      loading: true,
      refreshing: false,
      errorMsg: "",
      requests: [],
      perPage: 20,
      actionLoadingOrderId: null,

      confirmActive: false,
      confirmAction: null,
      confirmOrder: null,
      confirmSubmitting: false,
    };
  },
  computed: {
    confirmTitle() {
      return this.confirmAction === "accept" ? "تأكيد القبول" : "تأكيد الرفض";
    },
    confirmText() {
      if (!this.confirmOrder) return "";
      const code = this.confirmOrder.code || "";
      return this.confirmAction === "accept"
        ? `هل تريد قبول طلب المرتجع للطلب (${code})؟`
        : `هل تريد رفض طلب المرتجع للطلب (${code})؟`;
    },
  },
  created() {
    this.fetchReturnRequests();
  },
  methods: {
    formatDate(value) {
      if (!value) return "-";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      return d.toLocaleDateString("en-LY", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    async fetchReturnRequests() {
      this.errorMsg = "";
      this.refreshing = true;
      if (this.loading !== true) this.actionLoadingOrderId = null;

      try {
        const { data } = await axios.get("order/return-requests", {
          params: { perPage: this.perPage },
        });

        if (data && data.success === 1) {
          const response = data && data.response ? data.response : null;
          const feed = response && response.feed ? response.feed : [];
          this.requests = Array.isArray(feed) ? feed : [];
        } else {
          this.requests = [];
          const response = data && data.response ? data.response : null;
          this.errorMsg =
            (response && response.error_msg ? response.error_msg : "") ||
            (data && data.error_msg ? data.error_msg : "") ||
            "حدث خطأ أثناء تحميل الطلبات التي تحتاج متابعتك";
        }
      } catch (err) {
        this.requests = [];
        const responseData =
          err && err.response && err.response.data ? err.response.data : null;
        this.errorMsg =
          (responseData && responseData.error_msg ? responseData.error_msg : "") ||
          (responseData && responseData.message ? responseData.message : "") ||
          (err && err.message ? err.message : "") ||
          "حدث خطأ أثناء تحميل الطلبات التي تحتاج متابعتك";
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    setPerPage(value) {
      this.perPage = value;
      this.fetchReturnRequests();
    },
    openConfirm(order, action) {
      this.confirmOrder = order;
      this.confirmAction = action;
      this.confirmActive = true;
    },
    captainPhone(order) {
      if (!order) return '-';
      if (order.captain_phone1 && order.captain_phone2) {
        return `${order.captain_phone1} - ${order.captain_phone2}`;
      }
      return order.captain_phone1 || order.captain_phone2 || '-';
    },
    returnTypeText (status) {
      switch (status) {
        case 7:
        return "مدفوع";
        case 8:
        return "علي المرسل";
        case 9:
        return "الغاء";
        default:
        return "-";
      }
    },
    resetConfirm() {
      if (this.confirmSubmitting) return;
      this.confirmActive = false;
      this.confirmAction = null;
      this.confirmOrder = null;
    },
    async submitConfirm() {
      if (!this.confirmOrder || !this.confirmAction) return;
      if (!this.confirmOrder.return_request_type) return;

      this.confirmSubmitting = true;
      this.actionLoadingOrderId = this.confirmOrder.id;
      try {
        const payload = {
          order_id: this.confirmOrder.id,
          action: this.confirmAction,
          return_request_type: this.confirmOrder.return_request_type,
        };

        const { data } = await axios.post(
          'order/handle-return-request',
          payload
        );

        if (data && data.success) {
          const removedId = this.confirmOrder.id;
          this.requests = this.requests.filter((o) => o.id !== removedId);

          // close and reset confirmation popup after success
          this.confirmActive = false;
          this.resetConfirm();

          this.$vs.notify({
            title: 'نجاح',
            text:
              this.confirmAction === 'accept'
                ? 'تم قبول طلب المرتجع'
                : 'تم رفض طلب المرتجع',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
          });
        } else {
          this.$vs.notify({
            title: 'فشل',
            text:
              (data && data.error_msg ? data.error_msg : '') ||
              (data && data.message ? data.message : '') ||
              'لم يتم تنفيذ العملية',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
        }
      } catch (err) {
        const responseData =
          err && err.response && err.response.data ? err.response.data : null;
        this.$vs.notify({
          title: 'فشل',
          text:
            (responseData && responseData.error_msg ? responseData.error_msg : "") ||
            (responseData && responseData.message ? responseData.message : "") ||
            (err && err.message ? err.message : "") ||
            "لم يتم تنفيذ العملية",
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      } finally {
        this.confirmSubmitting = false;
        this.actionLoadingOrderId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
